import { setupResourceStore } from '@/utils'
import Batch from '@/resources/Batch';

const resource = setupResourceStore(Batch)


const state = {
  ...resource.state
};

const getters = {
  ...resource.getters
};

const actions = {
  ...resource.actions
};

const mutations = {
  ...resource.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};